module.exports = __webpack_public_path__ + "static/media/question-hover.ff52b219.svg";